var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"justify-center":"","items-center":"","text-xs-center":"","py-4":"","px-4":_vm.$vuetify.breakpoint.mdAndUp}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }